import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import config from '../config/config'
import ManagePoiNavBar from '../components/PointOfInterest/ManagePoiNavBar'
import PoiTechnicalSheet from '../components/PointOfInterest/PoiTechnicalSheet'
import { setFlashMessage } from '../contexts/WebsiteContext'

const ManageBeforeAfters = () => {
  const { t } = useTranslation()
  const { id } = useParams() // POI ID
  const [poi, setPoi] = useState(null)
  const [beforeFile, setBeforeFile] = useState(null)
  const [afterFile, setAfterFile] = useState(null)
  const [labelFr, setLabelFr] = useState('')
  const [labelEn, setLabelEn] = useState('')
  const [labelEs, setLabelEs] = useState('')

  useEffect(() => {
    const fetchPoi = async () => {
      try {
        const response = await axios.get(`${config.apiUrl}poi/${id}`)
        setPoi(response.data)
      } catch (error) {
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
      }
    }

    fetchPoi()
  }, [id, t])

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!beforeFile || !afterFile) {
      setFlashMessage(t('BOTH_PHOTOS_REQUIRED'), 'error')
      return
    }

    const formData = new FormData()
    formData.append('before', beforeFile)
    formData.append('after', afterFile)
    formData.append('poi', id)
    formData.append('labelFr', labelFr)
    formData.append('labelEn', labelEn)
    formData.append('labelEs', labelEs)

    try {
      await axios.post(`${config.apiUrl}before-after`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })

      setFlashMessage(t('PHOTO_UPLOADED_SUCCESS'), 'success')
      setBeforeFile(null)
      setAfterFile(null)
      setLabelFr('')
      setLabelEn('')
      setLabelEs('')
    } catch (error) {
      setFlashMessage(t('UPLOAD_ERROR'), 'error')
    }
  }

  return (
    <div>
      <NavigationBar />
      <h1>{t('MANAGE_BEFORE_AFTER')}</h1>
      <ManagePoiNavBar />
      {poi && <PoiTechnicalSheet poi={poi} />}

      <form
        onSubmit={handleSubmit}
        encType="multipart/form-data"
        className="before-after-form"
      >
        <div>
          <label>{t('BEFORE_PHOTO')}</label>
          <input
            type="file"
            onChange={(e) => setBeforeFile(e.target.files[0])}
            accept="image/*"
          />
        </div>
        <div>
          <label>{t('AFTER_PHOTO')}</label>
          <input
            type="file"
            onChange={(e) => setAfterFile(e.target.files[0])}
            accept="image/*"
          />
        </div>
        <div>
          <label>FR</label>
          <input
            type="text"
            value={labelFr}
            onChange={(e) => setLabelFr(e.target.value)}
          />
        </div>
        <div>
          <label>EN</label>
          <input
            type="text"
            value={labelEn}
            onChange={(e) => setLabelEn(e.target.value)}
          />
        </div>
        <div>
          <label>ES</label>
          <input
            type="text"
            value={labelEs}
            onChange={(e) => setLabelEs(e.target.value)}
          />
        </div>
        <button type="submit">{t('UPLOAD')}</button>
      </form>

      <Footer />
    </div>
  )
}

export default ManageBeforeAfters
